// src/utils/countryToCurrency.js
import countries from 'i18n-iso-countries'
import en from 'i18n-iso-countries/langs/en.json'
import countryToCurrency from 'country-to-currency'

countries.registerLocale(en)

// Common aliases / informal names -> ISO-ish names that i18n-iso-countries understands
const COUNTRY_ALIASES = {
  // Korea
  'korea': 'Korea, Republic of', // default "Korea" => South Korea
  'south korea': 'Korea, Republic of',
}

function normalizeCountryName(input) {
  if (!input) return null
  const raw = String(input).trim()
  if (!raw) return null

  // basic normalization for matching
  const key = raw
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .replace(/[().]/g, '')
    .trim()

  return COUNTRY_ALIASES[key] || raw
}

export function getCurrencyCodeFromCountry(countryName) {
  const normalized = normalizeCountryName(countryName)
  if (!normalized) return null

  const alpha2 = countries.getAlpha2Code(normalized, 'en')
  if (!alpha2) return null

  return countryToCurrency[alpha2.toUpperCase()] || null
}